import React, { useState } from 'react'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { Text, Spinner, Button } from '@ui-kitten/components'
import { passwordReset } from '../../global/Firebase/firebase'
import StyledTextInput from '../../components/StyledTextInput'
import * as Sentry from "@sentry/react-native"
import { useTranslation } from 'react-i18next'

export default function LoginScreen({ navigation }) {
  const { t } = useTranslation()
  const [loginError, setLoginError] = useState();
  const [success, setSuccess] = useState();
  const [isLoading, setIsLoading] = useState(false)
  const [email, setEmail] = useState('')

  async function resetPassword() {
    if (email === '') {
      setLoginError(t('login.emailRequired'))
      return
    }
    setIsLoading(true)
    try {
      await passwordReset(email)
      setSuccess(true)
      setIsLoading(false)
    } catch (error) {
      if (error.code === 'auth/user-not-found') {
        setLoginError(t('login.userNotFound'))
      } else if (error.code === 'auth/invalid-email') {
        setLoginError(t('login.invalidEmail'))
      } else if (error.code === 'auth/user-disabled') {
        setLoginError(t('login.userDisabled'))
      } else if (error.code === 'auth/too-many-requests') {
        setLoginError(t('login.tooManyRequests'))
      } else if (error.code === 'auth/network-request-failed') {
        setLoginError(t('login.networkRequestFailed'))
      } else {
        Sentry.captureException(error)
        setLoginError(error.message)
      }
      setIsLoading(false)
    }
  }

  return (
    <View style={styles.topContainer}>
      <View style={styles.container}>
        <Text category='label' style={styles.label}>
          {t('login.email')}
        </Text>
        <StyledTextInput 
          value={email}
          onChangeText={setEmail}
          keyboardType="email-address"
          textContentType="emailAddress"
          autoFocus={true}
          autoCapitalize="none"
          autoCorrect={false}
          style={styles.input}
          onSubmitEditing={({nativeEvent}) => {
            resetPassword()
          }}
        />
        {loginError != null && (<Text style={styles.submitButton} status='danger'>{loginError}</Text>)}
        {success != null && (<Text style={styles.submitButton} status='success'>
          {t('login.resetPasswordSuccess')}
        </Text>)}
        {isLoading ? (
            <View style={styles.spinner}><Spinner /></View>
          ) : (
            <Button onPress={resetPassword} style={styles.submitButton}>
              {t('login.resetPassword')}
            </Button>
          )
        }   
      </View>
    </View>
    
  );
}

const styles = StyleSheet.create({
  topContainer: {
    flex: 1, 
    alignItems: 'center',
  },
  container: {
    flex: 1,
    padding: 15,
    width: '90%',
    maxWidth: 800,
    // alignItems: 'center',
    // alignContent: 'center',
  },
  submitButton: {
    marginTop: 15,
  },
  spinner: {
    marginTop: 15,
    alignItems: 'center'
  },
  label: {
    marginTop: 10,
    marginBottom: 5,
  },
});
